/**
 * Authentication and authorization helper functions
 */

/**
 * Admin role names that grant administrative privileges
 * Note: 'universal_admin' is the canonical admin role name.
 * 'ApptronikAdmin' is kept for backwards compatibility.
 */
const ADMIN_ROLE_NAMES = ['universal_admin', 'ApptronikAdmin'];

/**
 * Check if a user object has admin privileges
 * @param {Object} user - User object with roles array
 * @returns {boolean} - True if user has admin role
 */
export const isAdmin = (user) => {
    if (!user || !user.roles) return false;
    return user.roles.some(role => ADMIN_ROLE_NAMES.includes(role.name));
};

export default { isAdmin, ADMIN_ROLE_NAMES };
